<template>
    <main class="smaller-padding data-table">

            <v-data-table :headers="headers"
                          :items="list"
                          :total-items="30"
                          :loading="loading"
                          :pagination.sync="sync"
                          :hide-actions="true"
                          :must-sort="true"
                          :no-data-text="$t('message.generics.message.noData')"
                          :no-results-text="$t('message.generics.message.noData')"
                          sort-icon="mdi-chevron-down">

                <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>

                <template slot="items" slot-scope="props">
                    <app-tag-table-item :data-item="props.item"></app-tag-table-item>
                </template>

            </v-data-table>

            <v-pagination v-if="totalPages"
                          v-model="sync.page"
                          color="primary"
                          :length="totalPages"
                          @input="setPage"></v-pagination>

    </main>
</template>

<script>
    import EventBus from '@packages/event-bus'
    import paginatedTable from '@mixins/paginated-table'
    import AppTagTableItem from './components/TagTableItem'

    export default {
        components: {
            AppTagTableItem,
        },

        data() {
            return {
                entity: 'tag'
            }
        },

        destroyed() {
            this.$store.commit('TAG_RESET_FILTERS')
        },

        mixins: [paginatedTable],

        computed: {
            filters() {
                return this.$store.state.tag.filters
            },

            headers() {
                return [
                    {text: this.$t('message.generics.message.description'), value: 'descricao'}
                ]
            }
        },

        mounted() {
                this.load()
                EventBus.$on('LOAD_TAGS', this.load)
        },

        beforeDestroy() {
                EventBus.$off('LOAD_TAGS', this.load)
        }
    }
</script>

<style scoped>

</style>



